export default __webpack_public_path__ + "static/media/planeta-ods.69f3c56d.jpg";